<template>
  <div class="">
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="0px"
      size="small"
    >
      <el-form-item label="" prop="content">
        <rich-editor
          class="editor"
          v-model="model.content"
          style="width: 750px"
        ></rich-editor>
      </el-form-item>
    </el-form>
    <el-button size="small" type="primary" @click="submitForm">保 存</el-button>
  </div>
</template>

<script>
import { getCustomConfig, createCustomConfig } from '@/service/getData'
import RichEditor from '@/components/rich-editor'

export default {
  components: {
    RichEditor,
  },
  data() {
    return {
      model: {
        type: 2,
        content: '',
      },
      rules: {
        content: [{ required: true, message: '请填写内容', trigger: 'change' }],
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await getCustomConfig({ type: this.model.type })
      if (res.data.id) {
        this.model = res.data
      }
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let res = await createCustomConfig(this.model)
          if (res.code == 0) {
            this.model = res.data
            this.$message.success('保存成功')
          }
        }
      })
    },
  },
}
</script>
<style scoped>
/deep/.ql-editor {
  min-height: 200px;
}

/deep/.ql-formats {
  line-height: 0;
}
</style>